<template>
  <v-footer color="black">
    <v-sheet
      :class="['footer__container d-flex', containerLayout, 'pt-4']"
      :min-height="`${footerHeight}px`"
      :style="footerStyleVars"
      color="transparent"
    >
      <v-sheet
        :class="['footer__column d-flex flex-column justify-start', isMobileOnly ? 'align-center' : '']"
        color="transparent"
      >
        <router-link
          :to="{ name: 'Home' }"
          class="footer__nav-link text-white text-decoration-none text-uppercase"
        >
          Home
        </router-link>
        <router-link
          :to="{ name: 'AboutUs' }"
          class="footer__nav-link text-white text-decoration-none text-uppercase"
        >
          Über Uns
        </router-link>
        <router-link
          :to="{ name: 'Mitglieder' }"
          class="footer__nav-link text-white text-decoration-none text-uppercase"
        >
          Mitglieder
        </router-link>
        <router-link
          :to="{ name: 'Termine' }"
          class="footer__nav-link text-white text-decoration-none text-uppercase"
        >
          Termine
        </router-link>
      </v-sheet>

      <v-sheet
        :class="['footer__column d-flex flex-column justify-start', isMobileOnly ? 'align-center' : '']"
        color="transparent"
      >
        <a
          class="footer__nav-link text-white text-decoration-none text-uppercase"
          href="mailto:kontakt@abtruennige.com?subject=Kontaktanfrage"
          rel="noopener noreferrer"
        >
          Kontakt
        </a>
        <router-link
          :to="{ name: 'Impressum' }"
          class="footer__nav-link text-white text-decoration-none text-uppercase"
        >
          Impressum
        </router-link>
        <router-link
          :to="{ name: 'Datenschutz' }"
          class="footer__nav-link text-white text-decoration-none text-uppercase"
        >
          Datenschutz
        </router-link>
      </v-sheet>

      <v-sheet
        :class="['footer__social d-flex justify-start', isMobileOnly ? 'align-start' : '']"
        color="transparent"
      >
        <v-btn
          color="background"
          height="34"
          icon="mdi-facebook"
          href="https://www.facebook.com/DieAbtruennigen/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Besuchen Sie uns auf Facebook"
          rounded
          width="34"
        />
        <v-btn
          color="background"
          height="34"
          icon="mdi-instagram"
          href="https://www.instagram.com/dieabtruennigen/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Folgen Sie uns auf Instagram"
          rounded
          width="34"
        />
      </v-sheet>
    </v-sheet>
  </v-footer>
</template>

<script lang="ts" setup>
import { computed, ref } from 'vue'
import { useMobileStore } from '@/stores/displayStore'
import { useDisplay } from 'vuetify'
import { useAppStore } from '@/stores/app'

const mobileStore = useMobileStore()
const appStore = useAppStore()
const { width } = useDisplay()

const footerHeight = ref(appStore.getElementSize().footer)

const isMobileOnly = computed(() => mobileStore.mobile && !mobileStore.tablet)

const footerStyleVars = computed(() => ({
  '--footer-gap': isMobileOnly.value ? '50px' : '0',
  '--footer-margin': width.value >= 1920 ? '17%' : width.value >= 1440 ? '6%' : '2.5%',
  '--footer-width': width.value >= 1920 ? '66%' : width.value >= 1440 ? '88%' : '95%'
}))

const containerLayout = computed(() =>
  isMobileOnly.value ? 'footer__container--stacked' : 'footer__container--wide'
)
</script>

<style scoped>
.footer__container {
  gap: var(--footer-gap);
  margin-left: var(--footer-margin);
  width: var(--footer-width);
}

.footer__container--stacked {
  flex-direction: column;
  align-items: center;
}

.footer__container--wide {
  justify-content: space-between;
}

.footer__column {
  gap: 6px;
}

.footer__nav-link {
  font-size: 14px;
}

.footer__social {
  gap: 10px;
}
</style>
